import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setManagerLoginModal } from '../actions/modalActions'
import { setSelectModal } from '../../actions/generalActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import ManagerLoginListItem from '../../components/ManagerLoginListItem'
import $ from 'jquery'
import PropTypes from 'prop-types'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'

class ManagerLoginModal extends Component {
    constructor(props) {
        super(props);
        this.cancelTap = this.cancelTap.bind(this);
        this.processTouchTap = this.processTouchTap.bind(this);
        this.showPassKeyboard = this.showPassKeyboard.bind(this);
        this.showList = this.showList.bind(this);
        this.handleListSelect = this.handleListSelect.bind(this);
        this.state = {
            username: this.props.getTranslation(resource.CHOOSE_USER),
            user: '',
            showItems: false
        };
    }

    cancelTap() {
        this.props.setManagerLoginModal([], false, 'default');
        this.setState({ username: this.props.getTranslation(resource.CHOOSE_USER), userid: '', showItems: false });
    }

    processTouchTap() {
        const managerUser = {
            User: this.state.user,
            Password: $('#password').val()
        }

        const callback = this.props.managerLoginModal.callback;
        const dispatch = this.props.managerLoginModal.dispatch;

        let callbackParams = [managerUser];

        if (this.props.managerLoginModal.callbackparams !== undefined) {
            this.props.managerLoginModal.callbackparams.map(param => {
                callbackParams.push(param);
                return '';
            })
        }

        this.setState({ username: this.props.getTranslation(resource.CHOOSE_USER), userid: '', showItems: false });

        this.props.setManagerLoginModal([], false, 'default');

        if (callback !== null) {
            if (dispatch !== null) {
                dispatch(callback.apply(this, callbackParams));
            } else {
                callback.apply(this, callbackParams);
            }
        }
    }

    showPassKeyboard() {
        const { 
			getTranslation,
            toggleKeyboard            
        } = this.props;
        toggleKeyboard(true, '#password', getTranslation(resource.PASSWORD), null, [], false);
    }

    showList() {
        this.setState({ showItems: true });
    }

    handleListSelect(user) {
        this.setState({ username: user.UserName, user: user, showItems: false });
    }

    render() {
        const { 
			keyboard,
            managerLoginModal
        } = this.props;

        return (
            <Modal className='managerLoginModal'
                contentLabel=""
                isOpen={managerLoginModal.show}
                style={properties.managerLoginModalStyle}
            >
                <div className="managerLoginModal_header">
                    <div className="header_top">
                        Manager login
                    </div>
                </div>
                <div className="managerLoginModal_content">
                    <div>
                        <div>
                            <button
                                className="inputfield"
                                onClick={this.showList}>
                                {this.state.username}
                            </button>
                        </div>
                        <div>
                            <input
                                id="password"
                                className="inputfield_pswrd"
                                type="password"
                                placeholder={keyboard.message}
                                onClick={this.showPassKeyboard}
                                readOnly="readOnly" />
                        </div>
                        <div className="logindiv">
                            {this.state.showItems ? managerLoginModal.listvalues.map(val =>
                                <ManagerLoginListItem
                                    key={val.User.SystemUserId}
                                    User={val.User}
                                    Callback={this.handleListSelect}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>
                <div className="managerLoginModal_footer">
                    <button className="btnCancel" onClick={this.cancelTap} >
                    {this.props.getTranslation(resource.CANCEL)}
                    </button>
                    <button className="btnLogin" onClick={this.processTouchTap} >
                        Login
                    </button>
                </div>

            </Modal>
        )
    }
}

ManagerLoginModal.propTypes = {
    setSelectModal: PropTypes.func.isRequired,
    toggleKeyboard: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
        managerLoginModal: state.modalState.managerLoginModal,
        keyboard: state.layoutState.keyboard,
    }
}

export default connect(mapStateToProps, {
    setManagerLoginModal,
    setSelectModal,
    toggleKeyboard,
    getTranslation
})(ManagerLoginModal)



// WEBPACK FOOTER //
// src/modal/components/ManagerLoginModal.jsx